import {CommonService} from '../../services/common.service';
import {Component, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {HqName} from '../../models/HqName';
import {MatSnackBar} from '@angular/material';

@Component({
  selector: 'app-head-quarters',
  styleUrls: ['./head-quarters.component.scss'],
  templateUrl: './head-quarters.component.html'
})
export class HeadQuartersComponent implements OnInit {
  public editedHqName: string;
  public hqDataSource: MatTableDataSource<HqName>;
  public hqNameColumns: string[] = ['name', 'actions'];
  public isHqEditable: boolean;
  public loading: boolean;
  public newName: string;
  private updateHqItem: any;

  constructor(private commonService: CommonService,
              private matSnackBar: MatSnackBar) {
    this.isHqEditable = false;
    this.loading = false;
  }

  async ngOnInit(): Promise<void> {
    await this.getHQNames();
  }

  async addHqName() {
    if (this.newName) {
      try {
        const result = await this.commonService.insertObject('head_quarter', {name: this.newName});
        this.toastMessages('Η κατηγορία δημιουργήθηκε με επιτυχία');
        const model = {
          id: result.id,
          name: this.newName,
          has_been_used: 0
        };
        const data = JSON.parse(JSON.stringify(this.hqDataSource.data));
        data.push(model);
        this.hqDataSource.data = data;
        this.resetHqName();
        this.toastMessages(`Το HQ δημιουργήθηκε με επιτυχία`);
      } catch (e) {
        this.toastMessages(`Αποτυχία δημιουργίας. Λόγος: ${e.message}`);
      }
    } else {
      this.toastMessages('Το όνομα δεν μπορεί να είναι κενό');
    }
  }

  applyFilterHqNames(value: any): void {
    this.hqDataSource.filter = value.trim().toLocaleLowerCase();
  }

  async deleteHq(id: number, index: number) {
    try {
      await this.commonService.deleteRecord(`head_quarter/${id}`);
      this.toastMessages('Το HQ διαγράφηκε με επιτυχία');
      const data = JSON.parse(JSON.stringify(this.hqDataSource.data));
      data.splice(index, 1);
      this.hqDataSource.data = data;
    } catch (e) {
    }
  }

  editHqName(id: any, index: any): void {
    this.isHqEditable = true;
    this.editedHqName = this.hqDataSource.data[index].name;
    this.updateHqItem = {
      id,
      index,
      name: this.hqDataSource.data[index].name
    };
  }

  async getHQNames(): Promise<any> {
    try {
      this.loading = true;
      const data = await this.commonService.getSimpleList('head_quarter') as HqName[];
      this.hqDataSource = new MatTableDataSource<HqName>(data);
    } catch (e) {
      throw e;
    } finally {
      this.loading = false;
    }
  }

  isDeleteHqDisabled(element: any): boolean {
    return element.has_been_used !== 0;
  }

  async updateHqName() {
    const data = JSON.parse(JSON.stringify(this.hqDataSource.data));
    const updatedItem = data.find(item => item.id === this.updateHqItem.id);

    const model = {
      id: this.updateHqItem.id,
      name: this.editedHqName,
      has_been_used: updatedItem.has_been_used
    };

    if (this.editedHqName) {
      try {
        await this.commonService.updateObject(`head_quarter/${model.id}`, {name: this.editedHqName});
        this.toastMessages('Η ενημέρωση ολοκληρώθηκε με επιτυχία');
      } catch (e) {
        this.toastMessages(`Η ενημέρωση απέτυχε. Λόγος: ${e.message}`);
      }

      const index = this.updateHqItem.index;
      data[index] = model;
      this.hqDataSource.data = data;

      this.resetHqName();
    } else {
      this.toastMessages('Το όνομα δεν μπορεί να είναι κενο');
    }
  }

  resetHqName(): void {
    this.newName = '';
    this.updateHqItem = {};
    this.isHqEditable = false;
    this.editedHqName = '';
  }

  toastMessages(message: string): void {
    this.matSnackBar.open(message, '', {
      duration: 5000,
    });
  }
}
